import React, { useState } from "react";
import { FiLock } from "react-icons/fi";
import { useAuth } from "../contexts/AuthContext";
import "./SetPasswordModal.css";

export default function SetPasswordModal({ onClose }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const { updateUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match. Please try again.");
      return;
    }

    setLoading(true);
    try {
      const { error: err } = await updateUser({ password });
      if (err) throw err;
      setDone(true);
      // Auto close after 2.5 seconds
      setTimeout(() => onClose(), 2500);
    } catch (err) {
      setError(err?.message || "Failed to set password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="spOverlay">
      <div className="spModal">
        {done ? (
          <div className="spSuccess">
            <div className="spSuccessIcon">✓</div>
            <h3>Password Set!</h3>
            <p>Your account is fully secured. You can now sign in with your email and password anytime.</p>
          </div>
        ) : (
          <>
            <div className="spHeader">
              <div className="spIconWrap">
                <FiLock />
              </div>
              <h2>Secure Your Account</h2>
              <p>
                Your email <strong>has been verified</strong>! Now create a password so you can log
                in easily next time without needing a magic link.
              </p>
            </div>

            <form className="spForm" onSubmit={handleSubmit}>
              {error && <p className="spError">{error}</p>}

              <label className="spLabel">Create Password</label>
              <input
                className="spInput"
                type="password"
                required
                placeholder="Minimum 6 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <label className="spLabel">Confirm Password</label>
              <input
                className="spInput"
                type="password"
                required
                placeholder="••••••••"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />

              <button className="spPrimary" type="submit" disabled={loading}>
                {loading ? "Setting up..." : "Set Password & Continue"}
              </button>

              <button
                type="button"
                className="spSkip"
                onClick={onClose}
              >
                Skip for now (you can set it later in Profile)
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
